module.exports = __webpack_public_path__ + "static/media/qrzn-archive.ac2f3ee6.png";